import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { ExternalLoginModel } from "../models/ExternalLoginModel";
import { AuthResult } from "../models/AuthResult";
import { disconnectConnection } from "../contexts/ConnectionContext";



interface AuthState{
    isAuthenticated: boolean;
    user: {
        id: string;
        name: string;
        email: string;
        avatar?: string;
    } | null;
    error: string | null;
    token: string | null;
    loading: boolean;
    charityVerified?: boolean;
    verificationError: string;
    charityName?: string;
    a:string;
    b:string;
    c:string;
}

const initialState: AuthState = {
    isAuthenticated: false,
    user: null,
    error: null,
    token: null,
    loading: false,
    charityVerified: false,
    verificationError: "",
    charityName: "",
    a:'',
    b:'',
    c:''
};

export const login = createAsyncThunk(
    "auth/login",
    async (payload: { userNameOrEmailAddress: string; password: string,rememberClient: boolean }, { rejectWithValue,dispatch }) => {
        try {
           
            const chainType = process.env.REACT_APP_BLOCKCHAIN_NETWORK || "evm";

            if(chainType === "evm"){
                localStorage.setItem("tenantId", "5");
                localStorage.setItem("tenancyName", 'pauls');
            }else{
                localStorage.setItem("tenantId", "4"); 
                localStorage.setItem("tenancyName", 'believe');
            }

            const tenantId = localStorage.getItem("tenantId")|| 5;

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/TokenAuth/Authenticate`, {
           
                method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Abp.TenantId': `${tenantId}` // Add tenant ID if required
            },
            body: JSON.stringify({
            userNameOrEmailAddress: payload.userNameOrEmailAddress,
            password: payload.password,
            rememberClient: payload.rememberClient
            })
        });

        if (!response.ok) {
           return rejectWithValue({
                    message: "Login failed",
                    code: "LOGIN_FAILED"
                });
        }

        const data = await response.json();        
        return data.result;
           
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    });

    export const externalLogin = createAsyncThunk(
  'auth/externalLogin',
  async (payload: ExternalLoginModel, { rejectWithValue }) => {
    try {
        const chainType = process.env.REACT_APP_BLOCKCHAIN_NETWORK || "evm";

        const tenantId = chainType === "evm" ?  "5" : "4"; // Default tenant ID for Solana

        const response:any = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/TokenAuth/ExternalAuthenticate`, {
           
                method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Abp.TenantId': `${tenantId}`, 
            },
            body: JSON.stringify(payload)});
            
      if (!response.ok) {
           return rejectWithValue({
                    message: "Login failed",
                    code: "LOGIN_FAILED"
                });
        }
        const data = await response.json();      
        return data.result; 
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const register = createAsyncThunk(
  "auth/register",
  async (payload: { 
    userName: string; 
    password: string; 
    emailAddress: string;
    phoneNumber: string;
    shopId: number; 
    isCharity: boolean 
  }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/services/app/Customers/Register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        // Handle different HTTP status codes
        if (response.status >= 500) {
          return rejectWithValue({
            message: "Service is temporarily unavailable. Please try again later.",
            code: "SERVICE_UNAVAILABLE",
            status: response.status
          });
        } else if (response.status === 409) {
          return rejectWithValue({
            message: "User already exists with this email address.",
            code: "USER_EXISTS",
            status: response.status
          });
        } else if (response.status === 400) {
          // Try to get validation errors from response
          try {
            const errorData = await response.json();
            return rejectWithValue({
              message: errorData.error?.message || "Invalid registration data",
              code: "VALIDATION_ERROR",
              status: response.status,
              details: errorData.error?.details
            });
          } catch {
            return rejectWithValue({
              message: "Invalid registration data",
              code: "VALIDATION_ERROR",
              status: response.status
            });
          }
        } else {
          return rejectWithValue({
            message: "Registration failed. Please try again.",
            code: "REGISTRATION_FAILED",
            status: response.status
          });
        }
      }

      const data = await response.json();
      return data.result;
    } catch (error: any) {
      // Handle network errors, timeouts, etc.
      if (error.name === 'TypeError' || error.message === 'Failed to fetch') {
        return rejectWithValue({
          message: "Unable to connect to the server. Please check your internet connection.",
          code: "NETWORK_ERROR"
        });
      } else if (error.name === 'AbortError') {
        return rejectWithValue({
          message: "Request timed out. Please try again.",
          code: "TIMEOUT_ERROR"
        });
      } else {
        return rejectWithValue({
          message: "An unexpected error occurred. Please try again.",
          code: "UNKNOWN_ERROR"
        });
      }
    }
  }
);

export const authenticateExternalUser = createAsyncThunk(
  "auth/authenticateExternalUser",
  async (payload:any,{rejectWithValue}) => {
    try{

         const response: any = await fetch(
      "/api/TokenAuth/ExternalAuthenticate",
      payload
    );    
    localStorage.setItem("token", response?.data?.result?.accessToken);
    localStorage.setItem("tenantId", response?.data?.result?.tenantId);
    localStorage.setItem("userId", response?.data?.result?.userId);
 return response;

    }catch(error:any){
      return rejectWithValue(error.message);
    }
   
   
  }
);

export const sendOtp = createAsyncThunk(
  "auth/sendOTP",   
    async (payload: { phoneNumber: string }, { rejectWithValue }) => {
        try {
         const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/TokenAuth/RequestPhoneAuthenticateOTP`, {           
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',            
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
           return rejectWithValue({
                    message: "OTP Login failed",
                    code: "OTP_LOGIN_FAILED"
                });
        }

        const data = await response.json();
       
        return data.result;

        } catch (error: any) {
        return rejectWithValue(error.message);
        }
    }
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOTP", 
    async (payload: { phoneNumber: string, otp: string }, { rejectWithValue }) => {
        try {
        // const response = await axios.post(
        //     "/api/services/app/Customers/VerifyOTP",
        //     payload
        // );

         const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/TokenAuth/AuthenticatePhoneOTP`, {           
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',            
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
           return rejectWithValue({
                    message: "Login failed",
                    code: "LOGIN_FAILED"
                });
        }

        const data = await response.json();
        
        return data.result;

        
        } catch (error: any) {
        return rejectWithValue(error.message);
    }
});

export const verifyCharityRegistration = createAsyncThunk(
  "auth/verifyCharityRegistration",
    async (payload: { charityId: string }, { rejectWithValue }) => {
        try {
        const response = await axios.post(`api/services/app/Charities/VerifyCharity?charityId=${payload.charityId}`
        );

        const result: {isRegistered: boolean, name: string} = {isRegistered: response.data.result.status, name: response.data.result.charityName};

        if (!result) {
            return rejectWithValue({
            message: "Charity verification failed",
            code: "CHARITY_VERIFICATION_FAILED"
            });
        }
    
       
        return result;
        } catch (error: any) {
        return rejectWithValue(error.message);
        }
    });

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        
        logout: (state:AuthState) => {
            state.isAuthenticated = false;
            state.user = null;
            state.token = null;
            state.error = null;
            localStorage.clear();
            sessionStorage.clear();
            // Disconnect SignalR connection if needed
            disconnectConnection();
        },setCharityNotVerified: (state:AuthState) => {
            state.charityVerified = false;
        }
    },extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state:AuthState, action: PayloadAction<{accessToken:string,encryptedAccessToken:string,expireInSeconds:number,userId:number,userDict:string[],pk:string}>) => {
                state.loading = false;
                state.isAuthenticated = true;               
                state.token = action.payload.accessToken;

                // console.log("Login response data:", action.payload);
                localStorage.setItem("token", action.payload.accessToken);              
                
                sessionStorage.setItem("a", action.payload.userDict[0]); // Adjust tenant ID as needed
                sessionStorage.setItem("b", action.payload.userDict[1]); // Adjust tenant ID as needed
                sessionStorage.setItem("c", action.payload.userDict[2]); // Adjust tenant ID as needed
                state.a = action.payload.userDict[0];
                state.b = action.payload.userDict[1];
                state.c = action.payload.userDict[2];
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.isAuthenticated = false;
                state.error = action.payload as string;
            })
            .addCase(register.pending, (state) => {
                state.loading = true;
                state.error = null;
            }
            )
            .addCase(register.fulfilled, (state:AuthState, action: PayloadAction<{id:number,name:string,emailAddress:string}>) => {
                state.loading = false;
                state.isAuthenticated = true;

                console.log("Registration response data:", action.payload);
                state.user = {
                    id: action.payload.id.toString(),
                    name: action.payload.name, // Placeholder, adjust as needed
                    email: action.payload.emailAddress, // Placeholder, adjust as needed
                    avatar: "" // Placeholder, adjust as needed
                };
                
            })
            .addCase(register.rejected, (state, action) => {
                state.loading = false;
                state.isAuthenticated = false;
                state.error = action.payload as string
            })
            .addCase(verifyCharityRegistration.pending, (state) => {
                state.loading = true;       
                state.verificationError = '';
            })
            .addCase(verifyCharityRegistration.fulfilled, (state:AuthState, action: PayloadAction<{isRegistered:boolean, name:string}>) => {
                state.loading = false;
                state.charityVerified = action.payload.isRegistered;
                state.charityName = action.payload.name;
                if(!action.payload.isRegistered){
                    state.verificationError = "Charity is not registered";
                }
                // console.log("Charity verification response data:", action.payload);
            })
            .addCase(verifyCharityRegistration.rejected, (state, action) => {   
                state.loading = false;
                state.isAuthenticated = false;
                state.verificationError = action.payload as string
            })
            .addCase(externalLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(externalLogin.fulfilled, (state, action:PayloadAction<AuthResult>) => {
                state.loading = false;
                // handle successful login if needed

                console.log("External login response data:", action.payload);

                state.isAuthenticated = true;               
                state.token = action.payload.accessToken;

                // console.log("Login response data:", action.payload);
                localStorage.setItem("token", action.payload.accessToken);              
                
                sessionStorage.setItem("a", action.payload.userDict[0]); // Adjust tenant ID as needed
                sessionStorage.setItem("b", action.payload.userDict[1]); // Adjust tenant ID as needed
                sessionStorage.setItem("c", action.payload.userDict[2]); // Adjust tenant ID as needed
      })
      .addCase(externalLogin.rejected, (state, action) => {
        state.loading = false;
        console.error("External login failed:", action.payload);
        state.error = action.payload as string;
      }).addCase(sendOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      }).addCase(sendOtp.fulfilled, (state, action:PayloadAction<{success:boolean}>) => {
        state.loading = false;
        if(action.payload.success){
            state.error = null;
        }else{
            state.error = "Failed to send OTP";
        }
      }).addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(verifyOtp.pending, (state) => {      
        state.loading = true;
        state.error = null;
      })
        .addCase(verifyOtp.fulfilled, (state, action:PayloadAction<{accessToken:string,encryptedAccessToken:string,expireInSeconds:number,userId:number,userDict:string[],pk:string}>) => {
            state.loading = false;
            state.isAuthenticated = true;               
            state.token = action.payload.accessToken;
    
            // console.log("Login response data:", action.payload);
            localStorage.setItem("token", action.payload.accessToken);              
                    
            sessionStorage.setItem("a", action.payload.userDict[0]); // Adjust tenant ID as needed
            sessionStorage.setItem("b", action.payload.userDict[1]); // Adjust tenant ID as needed
            sessionStorage.setItem("c", action.payload.userDict[2]); // Adjust tenant ID as needed
        }).addCase(verifyOtp.rejected, (state, action) => {
            state.loading = false;
            state.isAuthenticated = false;
            state.error = action.payload as string;
        });
    }
});

export const { logout,setCharityNotVerified } = authSlice.actions;
export default authSlice.reducer;